import { render, staticRenderFns } from "./webPageContent.vue?vue&type=template&id=70396960&scoped=true&"
import script from "./webPageContent.vue?vue&type=script&lang=js&"
export * from "./webPageContent.vue?vue&type=script&lang=js&"
import style0 from "./webPageContent.vue?vue&type=style&index=0&id=70396960&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70396960",
  null
  
)

export default component.exports